import { Logger } from '../../../logger/Logger';
import type { CoreStoreType } from '../../../store/CoreStore';
import { autoplayActions } from '../../../store/slices/autoplay/slice';

import { IncomingMessage } from './types';

export const CrossOriginCommunicationDefaultProcessor = (message: IncomingMessage, store: CoreStoreType): void => {
  switch (message) {
    case IncomingMessage.StopAutoplay:
      store.dispatch(autoplayActions.stop());
      Logger.logEvent('autoplay_stop', {
        additional: 'OperatorRequest',
      });
      break;
    default:
      break;
  }
};
